import React from 'react';
import { TextField } from 'components/ui';
import { FormattedMessage, useIntl } from 'react-intl';
import Form from 'components/filter/from';

const FilterForm = ({ initialValues, defaultValues, processing, onSubmit, onClose }) => {
  const intl = useIntl();

  return (
    <Form
      header={<FormattedMessage id="header.inspection_subject.filter" />}
      processing={processing}
      onClose={onClose}
      initialValues={initialValues}
      onSubmit={onSubmit}
      defaultValues={defaultValues}
      contentRenderer={(formik) => (
        <>
          <TextField
            fullWidth
            autoFocus
            margin="dense"
            id="name"
            name="name"
            label={intl.formatMessage({ id: 'name' })}
            value={formik.values.name}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={(formik.touched.name && Boolean(formik.errors.name)) || undefined}
            helperText={formik.touched.name && formik.errors.name}
          />
          <TextField
            fullWidth
            margin="dense"
            id="serialNumber"
            name="serialNumber"
            label={intl.formatMessage({ id: 'inspection_subject.serial_number' })}
            value={formik.values.serialNumber}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              (formik.touched.serialNumber && Boolean(formik.errors.serialNumber)) || undefined
            }
            helperText={formik.touched.serialNumber && formik.errors.serialNumber}
          />
        </>
      )}
    />
  );
};

export default FilterForm;
